// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { IProfile, IUserDetail } from '~/utils/interface/user';
import {
  changePasswordUser,
  createUser,
  deleteUser,
  getDetailUser,
  getListUser,
  getProfile,
  updateUser,
} from './userThunk';

export interface IUserState {
  userDetail: IUserDetail;
  profile: IProfile;
  isRefreshUserList: boolean;
  isRefreshProfile: boolean;
}

export const initialState: IUserState = {
  userDetail: {} as IUserDetail,
  profile: {} as IProfile,
  isRefreshUserList: false,
  isRefreshProfile: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setRefreshUserList(state, action) {
      state.isRefreshUserList = action.payload;
    },

    setRefreshProfile(state, action) {
      state.isRefreshProfile = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list user
    builder
      .addCase(getListUser.pending, (_state) => {})
      .addCase(getListUser.fulfilled, (_state) => {})
      .addCase(getListUser.rejected, (_state) => {});

    // GET: Get detail user
    builder
      .addCase(getDetailUser.pending, (state) => {
        state.userDetail = {} as IUserDetail;
      })
      .addCase(getDetailUser.fulfilled, (state, action) => {
        state.userDetail = action.payload.data;
      })
      .addCase(getDetailUser.rejected, (_state) => {});

    // POST: Create user
    builder
      .addCase(createUser.pending, (_state) => {})
      .addCase(createUser.fulfilled, (_state) => {})
      .addCase(createUser.rejected, (_state) => {});

    // PUT: Update user
    builder
      .addCase(updateUser.pending, (_state) => {})
      .addCase(updateUser.fulfilled, (_state) => {})
      .addCase(updateUser.rejected, (_state) => {});

    // DELETE: delete user
    builder
      .addCase(deleteUser.pending, (_state) => {})
      .addCase(deleteUser.fulfilled, (_state) => {})
      .addCase(deleteUser.rejected, (_state) => {});

    // POST: change password user
    builder
      .addCase(changePasswordUser.pending, (_state) => {})
      .addCase(changePasswordUser.fulfilled, (_state) => {})
      .addCase(changePasswordUser.rejected, (_state) => {});

    // GET: Get Profiles
    builder
      .addCase(getProfile.pending, (_state) => {})
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profile = action.payload.data;
        state.isRefreshProfile = false;
      })
      .addCase(getProfile.rejected, (_state) => {});
  },
});

// Action
export const userActions = userSlice.actions;

// Selectors
export const selectIsRefreshListUser = (state: RootState) => state.user.isRefreshUserList;
export const selectDetailUser = (state: RootState) => state.user.userDetail;
export const selectProfile = (state: RootState) => state.user.profile;
export const selectIsRefreshProfile = (state: RootState) => state.user.isRefreshProfile;

// Reducer
const userReducer = userSlice.reducer;
export default userReducer;
